import { cn } from "@/lib/utils";

interface CategoryTagProps {
  label: string;
  className?: string;
}

export function CategoryTag({ label, className }: CategoryTagProps) {
  return (
    <span className={cn("category-tag", className)}>
      {label}
    </span>
  );
}
